import React from 'react';
import { Link } from 'react-router-dom';
import { ChartBarIcon } from '@heroicons/react/24/outline';

const Logo = ({ 
  darkMode = false,
  size = 'md',
  linkTo = null,
  className = '',
  showIcon = true,
  compact = false,
}) => {
  // Size configurations
  const sizeConfig = {
    sm: {
      text: 'text-base',
      icon: 'w-4 h-4'
    },
    md: {
      text: 'text-xl',
      icon: 'w-5 h-5'
    },
    lg: {
      text: 'text-2xl',
      icon: 'w-6 h-6'
    }
  };

  const currentSize = sizeConfig[size] || sizeConfig.md;

  const logoContent = (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className={`font-bold ${currentSize.text} tracking-tight ${
        darkMode ? 'text-gray-100' : 'text-gray-900'
      }`}>
        {compact ? (<><span className="text-emerald-500">q</span>b</>) : (<><span className="text-emerald-500">query</span>burst</>)}
      </span>
      {showIcon && (
        <ChartBarIcon className={`${currentSize.icon} text-emerald-500 rotate-45`} />
      )}
    </div>
  );

  // Return as link or plain div based on linkTo prop
  if (linkTo) {
    return (
      <Link to={linkTo} className="inline-block">
        {logoContent}
      </Link>
    );
  }

  return logoContent;
};

export default Logo; 